import dayjs from 'dayjs';
import WeekOfYear from 'dayjs/plugin/weekOfYear';
import QuarterOfYear from 'dayjs/plugin/quarterOfYear';

/* 一周7天 */
const DAYS_OF_WEEK = 7;
/* 默认是中文版的星期一开始 */
const DEFAULT_WEEK_START = 1;
const DEFAULT_FORMAT = "YYYY-MM-DD HH:mm:ss";
const DEFAULT_FORMAT_BY_DATE = "YYYY-MM-DD";
const DEFAULT_PANEL_BODY_TABLE_ROW_NUM = 4;
const DEFAULT_PANEL_BODY_TABLE_COL_NUM = 3;

const DEFAULT_YEAR_SPAN_NUM = 10;
const DEFAULT_DECADE_SPAN_NUM = 100;

dayjs.extend(WeekOfYear);
dayjs.extend(QuarterOfYear);

const unSupportFormatReg = new RegExp(/(MMM)+/);

function isUnSupportFormat(format){
    return unSupportFormatReg.test(format);
}

function getUnSupportFormatDate(dateString, format){
    if(!dateString) {return null;}
    format = Array.isArray(format) ? format[0] : format;
    if(unSupportFormatReg.test(format)){
        if(format.length >= 500) {return null;}
        let reg = new RegExp(/^(YY|YYYY)([^YMD]*?)(M{1,4})([^YMD]*?)(D{1,2})([^YMD]*?)\s(HH|hh)([^hmsHMS]*?)(MM|mm)([^hmsHMS]*?)(SS|ss)([^hmsHMS]*?)$/).exec(format),
            splitStr = reg?.length > 0 ? new Set([reg[2], reg[4], reg[6]]) : new Set();

        [...splitStr].forEach(ch => {
            if(!ch) {return;} //避免空字符串
            ch = new RegExp(ch, 'g');
            format = format.replace(ch, ' ');
            dateString = dateString?.replace(ch, ' ');
        });

        // 不写正则式的写法
        // let matchChar = ['Y', 'M', 'D'], matchIndex = 0, matchSplitStr = new Set(), currentSplit = '';
        // for(let i = 0; i < format.length; i++){
        //     if(format[i] !== matchChar[matchIndex]){
        //         if(format[i + 1] === matchChar[matchIndex + 1]) {// 分隔符结束
        //             matchSplitStr.add((currentSplit || '').concat(format[i]));
        //             matchIndex += 1;
        //             currentSplit = '';
        //         } else {
        //             if(format[i - 1] === matchChar[matchIndex]) {// 分隔符开始
        //                 currentSplit = format[i];
        //             } else {
        //                 currentSplit = currentSplit.concat(format[i]); // 多个分隔符的情况
        //             }
        //         }
        //     }
        // }

        // [...matchSplitStr].forEach(ch => {
        //     ch = new RegExp(ch, 'g');
        //     format = format.replace(ch, ' ');
        //     dateString = dateString?.replace(ch, ' ');
        // });
    }
    return dayjs(dateString, format);
}

function validate(date){
    // //console.log('validate', date && dayjs(date).isValid());
    return date && dayjs(date).isValid();
}

/* 获取给定日期的年份 */
function getYear(date){
    if(!validate(date)){
        return getNow().year();
    }
    //console.log('getYear', dayjs(date).year());
    return date.year();
}

/* 获取指定日期的一年中的第几周 */
function getWeek(date){
    if(!validate(date)){
        return getNow().week();
    }
    //console.log('getWeek', dayjs(date).week());
    return date.week();
}

function getDecadeYear(date){
    if(!validate(date)){
        console.warn(`日期${date}不合法`);
        return;
    }
    let start = date.year();
    let end = start + DEFAULT_YEAR_SPAN_NUM - 1;
    return `${start}-${end}`;
}

/* 获取给定日期的月份, lib库返回从0开始，统一加1统一为实际月份 */
function getMonth(date){
    if(!validate(date)){
        return getNow().month() + 1;
    }
    //console.log('getMonth',date.month() + 1);
    return date.month() + 1;
}

function getQuarter(date){
    if(!validate(date)){
        return getNow().quarter();
    }
    return date.quarter();
}

/* 获取当前时间 */
function getNow(){
    //console.log('getNow', dayjs().format(DEFAULT_FORMAT));
    return dayjs();
}

/* 格式化显示时间 */
function formatValue(date, attr){ /* attr内可考虑添加多时区的配置之类的，暂时只有format，给一个默认的format */
    // if(!date) return 'Invalid Date';
    let format = attr && attr.format;
    date = date ? date : getNow();
    let show = typeof format === 'function' ? format(date.toDate()) : typeof format === 'string' ? date.format(format) : date.format(DEFAULT_FORMAT);
    //console.log('formatValue', show);
    return show;
}

function formatValueForDate(date, attr){
    let format = attr && attr.format;
    if(!date) {return date;}
    let show = typeof format === 'function' ? format(date.toDate()) : typeof format === 'string' ? date.format(format) : date.format(DEFAULT_FORMAT_BY_DATE);
    //console.log('formatValueForDate', show);
    return show;
}

function getWeekIndexOfYear(date){
    return date.week();
}

/* 获取要显示的第一天的日期，比如1号是周二，需要返回上个月的最后一天 */
function getMonthShowStart(date, weekDiff){
    let monthFirstDay = setDate(date, 1);
    let startWeekDayOfFirstDay = getWeekFirstDay(monthFirstDay, weekDiff);
    return startWeekDayOfFirstDay;
}

function getMonthFirstDay(date){
    return date.startOf('month');
}

function getMonthLastDay(date, dayDiff=0){
    return addDate(date.endOf('month'), dayDiff);
}

/* 获取日期所在周的第一天，由于默认周结束为周六而非周日，因此需要再加1天 */
function getWeekLastDay(date, weekDiff = 0){
    if(date.day() === weekDiff - 1){
        date = addWeek(date, -1);
    }
    return addDate(date.endOf('week'), weekDiff);
}

/* 获取日期所在周的第一天，由于默认周起始为周日而非周一，因此需要再减1天 */
function getWeekFirstDay(date, weekDiff = 0){
    // console.log('获取一周起始日,当前偏差', weekDiff, '日期', date.format('YY-MM-DD'), '周几?', date.day() + 1);
    if(date.day() === weekDiff - 1){
        // console.log('是周日，取上一周');
        date = addWeek(date, -1);
    }
    return addDate(date.startOf('week'), weekDiff);
}

/* 判断targetDate是否在baseDate的指定mode范围内，如targetDate的日期是否在mode=month时，在baseDate的月范围内 */
function isCurrentRange(targetDate, baseDate, mode){
    if(!validate(targetDate)){
        console.warn(`日期${targetDate}不合法`);
        return true;
    }
    let now = validate(baseDate) ? baseDate : getNow();
    // console.log('isCurrentRange', now.format(DEFAULT_FORMAT), formatValue(targetDate), mode);
    switch(mode){
        case 'date':
        case 'week':
            return targetDate.isSame(now, 'month');
        case 'year':
            let startYear = getYearShowStart(now);
            let endYear = addYear(startYear, DEFAULT_YEAR_SPAN_NUM - 1).endOf('year');
            return targetDate.isSame(startYear) || targetDate.isAfter(startYear) && targetDate.isBefore(endYear);
        case 'decade':
            let startDecade = getDecadeYearStart(now);
            let endDecade = addDecade(startDecade, DEFAULT_YEAR_SPAN_NUM - 1).endOf('year');
            return targetDate.isSame(startDecade) || targetDate.isAfter(startDecade) && targetDate.isBefore(endDecade);
        default:
            return true;
    }
}

/* 设置日期 */
function setDate(date, value){
    //console.log('setDate', date.date(value).format(DEFAULT_FORMAT));
    return date.date(value);
}

function setMonth(date, value){
    return date.month(value);
}

function setYear(date, value){
    return date.year(value);
}

/* 根据日期和diff计算日期, 日期 、 年 、 月 */
function addDate(baseDate, diff){
    if(!baseDate) {return baseDate;}
    // console.log('addDate', baseDate.add(diff, 'day').format(DEFAULT_FORMAT), dayjs.isDayjs(baseDate));
    return baseDate.add(diff, 'day');
}

function addYear(baseDate, diff){
    //console.log('addYear', baseDate.add(diff, 'year').format(DEFAULT_FORMAT));
    return baseDate.add(diff, 'year');
}

function addDecade(baseDate, diff){
    //console.log('addDecade', baseDate.add(diff * 10, 'year').format(DEFAULT_FORMAT));
    return baseDate.add(diff * DEFAULT_YEAR_SPAN_NUM, 'year');
}

function addMonth(baseDate, diff){
    //console.log('addMonth', baseDate.add(diff, 'month').format(DEFAULT_FORMAT));
    return baseDate.add(diff, 'month');
}

function addWeek(baseDate, diff){
    //console.log('addWeek', baseDate.add(diff, 'week').format(DEFAULT_FORMAT));
    return baseDate.add(diff, 'week');
}

function addQuarter(baseDate, diff){
    //console.log('addWeek', baseDate.add(diff, 'week').format(DEFAULT_FORMAT));
    return baseDate.add(diff, 'quarter');
}

function getQuarterFirstDay(date){
    return date.startOf('quarter');
}

function getQuarterLastDay(date){
    return date.endOf('quarter');
}

/* 周的显示头 */
function getWeekHeader(locale, offset){
    let base = 25; /* 强相关：多语的key值 */
    let target = base + offset;
    let max = base + DAYS_OF_WEEK;
    let clone = [];
    for(let i = target; i < max; i++){
        clone.push(locale[`00${i}`]);
    }
    if(clone.length < DAYS_OF_WEEK){
        let left = DAYS_OF_WEEK - clone.length;
        for(let i = 0; i < left; i++){
            clone.push(locale[`00${base + i}`]);
        }
    }
    return clone;//常量 一周的天数给常量赋值
}

/* 获取年区间的起始年的日期 */
function getYearShowStart(date){
    let currentYear = getYear(date);
    let startYear = Math.floor(currentYear / DEFAULT_YEAR_SPAN_NUM) * DEFAULT_YEAR_SPAN_NUM;
    let dayjsOfStart = date.year(startYear);
    //console.log('getYearShowStart', dayjsOfStart.format(DEFAULT_FORMAT));
    return dayjsOfStart;
}

function getYearFirstDay(date){
    return date.startOf('year');
}

function getYearLastDay(date){
    return date.endOf('year');
}

function getDecadeYearStart(date){
    let currentYear = getYear(date);
    let startYear = Math.floor(currentYear / DEFAULT_DECADE_SPAN_NUM) * DEFAULT_DECADE_SPAN_NUM;
    let dayjsOfStart = date.year(startYear);
    //console.log('getDecadeYearStart', dayjsOfStart.format(DEFAULT_FORMAT));
    return dayjsOfStart;
}

function isSame(date, baseDate, type){
    if(!date || !baseDate){
        return false;
    }

    if (!validate(date) || !validate(baseDate)) {
        return false;
    }

    switch(type){
        case 'date':
            return date.isSame(baseDate, 'date');
        case 'year':
            return date.isSame(baseDate, 'year');
        case 'month':
            return date.isSame(baseDate, 'month');
        case 'week':
            return date.isSame(baseDate, 'week');
        case 'decade':
            let decadeStart = getYearShowStart(baseDate);
            let decadeEnd = addYear(decadeStart, DEFAULT_YEAR_SPAN_NUM - 1);
            return date.isSame(decadeStart, 'year') || date.isSame(decadeEnd, 'year') || (date.isAfter(decadeStart) && date.isBefore(decadeEnd));
        default:
            return false;
    }
}

function isAfter(date, baseDate, type){
    if(!date || !baseDate) {return false;}

    if (!validate(date) || !validate(baseDate)) {
        return false;
    }

    switch(type){
        case 'date':
            return date.isAfter(baseDate, 'date');
        case 'year':
            return date.isAfter(baseDate, 'year');
        case 'month':
            return date.isAfter(baseDate, 'month');
        case 'week':
            return date.isAfter(baseDate, 'week');
        case 'decade':
            let start = getYearShowStart(baseDate);
            let end = addYear(start, DEFAULT_YEAR_SPAN_NUM - 1);
            return date.isAfter(end, 'year');
        default:
            return date.isAfter(baseDate);
    }
}

function isBefore(date, baseDate, type){
    if(!date || !baseDate) {return false;}

    if (!validate(date) || !validate(baseDate)) {
        return false;
    }

    switch(type){
        case 'date':
            return date.isBefore(baseDate, 'date');
        case 'year':
            return date.isBefore(baseDate, 'year');
        case 'month':
            return date.isBefore(baseDate, 'month');
        case 'week':
            return date.isBefore(baseDate, 'week');
        case 'decade':
            let start = getYearShowStart(baseDate);
            return date.isBefore(start, 'year');
        default:
            return date.isBefore(baseDate);
    }
}

function getDate(date){
    return date.date();
}

function getEndDate(date){
    return date.endOf('month');
}

function getCellDateDisabled(cellDate, mode, disableDateCb){
    if(!disableDateCb || typeof disableDateCb !== 'function') {return false;}
    const getDisabledFromRange = function(mode, start, end ){
        var current = start;
        while (current <= end) {
            var date;
            switch (mode) {
                case 'date':
                    date = setDate(cellDate, current);
                    if (!disableDateCb(date)) {
                        return false;
                    }
                    break;
                case 'month':
                    date = setMonth(cellDate, current);
                    if (!getCellDateDisabled(date, 'month', disableDateCb)) {
                        return false;
                    }
                    break;
                case 'year':
                    date = setYear(cellDate, current);
                    if (!getCellDateDisabled(date, 'year', disableDateCb)) {
                        return false;
                    }
                    break;
            }
            current += 1;
        }
        return true;
    };

    switch (mode) {
        case 'date':
        case 'week':
            return disableDateCb?.(cellDate) || false;
        case 'month':
            var startDate = 1;
            var endDate = getDate(getEndDate(cellDate));
            return getDisabledFromRange('date', startDate, endDate);
        case 'year':
            return getDisabledFromRange('month', 0, 11);
        case 'decade':
            var year = getYear(cellDate);
            var startYear = Math.floor(year / DEFAULT_YEAR_SPAN_NUM) * DEFAULT_YEAR_SPAN_NUM;
            var endYear = startYear + DEFAULT_YEAR_SPAN_NUM - 1;
            return getDisabledFromRange('year', startYear, endYear);
    }
}

function setTime(date, hour, minute, second, millisecond){
    let result = date;
    result = hour ? result.hour(hour) : result;
    result = minute ? result.minute(minute): result;
    result = second ? result.second(second): result;
    result = millisecond ? result.millisecond(millisecond): result;
    return result;
}

function toDayjs(date){
    if(!validate(date)){
        return null;
    }
    let result = dayjs(date);
    if(typeof date === 'string' && date.indexOf(':') === -1){
        let now = getNow();
        result = result.hour(now.hour()).minute(now.minute()).second(now.second()).millisecond(now.millisecond());
    }
    return result;
}

/* 本工具类目前内部均使用dayjs对象，接受和返回均使用Date对象,以便以后替换lib接口不受影响 */
function wrapper(fn){
    /* 当参数验证不通过时，赋值为当前日期是否合理还需确认 */
    const old = function(...args){
        for(let i = 0; i < args.length; i++){
            if(args[i] instanceof Date){
                args[i] = dayjs(args[i]);
                // console.log('参数', i, '转换dayjs', args[i].format(DEFAULT_FORMAT));
            }
        }
        const rst = fn.call(this, ...args);
        if(!rst || !dayjs.isDayjs(rst)) {
            return rst;
        }
        return rst.toDate();
    };
    return old;
}
const DateUtil = {
    /* 获取常量 */
    DEFAULT_WEEK_START,
    DAYS_OF_WEEK,
    DEFAULT_PANEL_BODY_TABLE_ROW_NUM,
    DEFAULT_PANEL_BODY_TABLE_COL_NUM,
    getWeekHeader: wrapper(getWeekHeader),

    /* 验证 */
    validate,
    toDayjs,
    isUnSupportFormat,
    getUnSupportFormatDate,

    /* 获取指定的年月日 */
    getNow: wrapper(getNow),
    getDate: wrapper(getDate),
    getWeek: wrapper(getWeek),
    getMonth: wrapper(getMonth),
    getQuarter: wrapper(getQuarter),
    getYear: wrapper(getYear),
    getDecadeYear: wrapper(getDecadeYear),

    /* 设置指定的值 */
    setTime: wrapper(setTime),
    setDate: wrapper(setDate),
    setMonth: wrapper(setMonth),

    /* 加减指定的日期跨度 */
    addDate: wrapper(addDate),
    addWeek: wrapper(addWeek),
    addMonth: wrapper(addMonth),
    addQuarter: wrapper(addQuarter),
    addYear: wrapper(addYear),
    addDecade: wrapper(addDecade),

    /* 获取指定的第一天和最后一天 */
    getWeekLastDay: wrapper(getWeekLastDay),
    getWeekFirstDay: wrapper(getWeekFirstDay),
    getMonthFirstDay: wrapper(getMonthFirstDay),
    getMonthLastDay: wrapper(getMonthLastDay),
    getQuarterFirstDay: wrapper(getQuarterFirstDay),
    getQuarterLastDay: wrapper(getQuarterLastDay),
    getYearFirstDay: wrapper(getYearFirstDay),
    getYearLastDay: wrapper(getYearLastDay),

    /* 格式化 */
    formatValue: wrapper(formatValue),
    formatValueForDate: wrapper(formatValueForDate),

    /* 判断 */
    isCurrentRange: wrapper(isCurrentRange),
    isSame: wrapper(isSame),
    isAfter: wrapper(isAfter),
    isBefore: wrapper(isBefore),

    /* 获取月面板的起始显示日期 */
    getMonthShowStart: wrapper(getMonthShowStart),
    /* 获取年面板的起始显示日期 */
    getYearShowStart: wrapper(getYearShowStart),

    /* 获取在年内是第几周 */
    getWeekIndexOfYear: wrapper(getWeekIndexOfYear),

    /* 获取区间年的起始年份 */
    getDecadeYearStart: wrapper(getDecadeYearStart),

    /* 判断单元的日期是否可用 */
    getCellDateDisabled: wrapper(getCellDateDisabled),

};

export default DateUtil;